import { $ } from '../lib/selectors';

export default function init() {
  const navEl = $('.js-nav');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      navEl.classList[entries[0].intersectionRatio > 0 ? 'remove' : 'add']('is-sticky');
    }, {threshold: [0]})
    observer.observe($('.js-nav-trigger'));
  } else {
    navEl.classList.add('is-sticky');
  }
}
